import styled, { css } from 'styled-components';
import { media } from '@minecraft.themes';
import Icon from '@minecraft.icon';

export const FilterBasicFormContainer = styled.div<{ $asOverlay: boolean }>`
  ${(props): any =>
    props.$asOverlay
      ? css`
          z-index: 100;
          height: 100%;
          width: 100%;
          position: fixed;
          top: 0;
          left: 0;
          display: inline-flex;
          flex-direction: column;
          padding: 0 1rem;
          background-color: ${props.theme.filters.overlay.backgroundColor};
          border: 1px solid ${props.theme.filters.overlay.borderColor};
          border-radius: 0.25rem;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
          overflow: auto;
          padding-bottom: 1rem;
        `
      : css`
          background-color: ${props.theme.filters.basic.backgroundColor};
          border: 1px solid ${props.theme.filters.basic.borderColor};
          border-radius: 0.25rem;
          margin-top: 0.5rem;
          padding: 0.5rem;
        `}
`;

export const FilterBasicContentHeader = styled.div`
  color: ${(props): string => props.theme.filters.color};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  padding: 1.5rem 0;
  border-bottom: 1px solid ${(props): string => props.theme.colors.accent.ltGrey4};

  h3 {
    margin: 0;
    color: inherit;
  }
`;

export const FormFieldList = styled.div`
  ${media.sm`
    display: flex;
    flex-wrap: wrap;
    flex: auto;
    margin-left: -1rem;
    margin-bottom: 0.5rem;

    & > * {
      margin: 0.625rem 0 0 1rem;
    }
  `}
`;

export const ButtonGroup = styled.div`
  ${media.sm`
    flex-grow: 1;
    margin: 0.625rem 0 0 1rem;
    text-align: right;
  `}

  & > * {
    width: 100%;
    font-size: 1rem;
    height: 2.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;

    &:not(:last-child) {
      margin-bottom: 1rem;
    }

    ${media.sm`
      font-size: 0.875rem;
      height: 2rem;
      min-width: auto;
      width: auto;

      &:not(:last-child) {
        margin-bottom: 0;
        margin-right: 1rem;
      }
    `}
  }
`;

export const CloseIcon = styled(Icon)`
  cursor: pointer;
  height: 1.375rem;
  width: 1.375rem;
`;
